// // import React, { Fragment, useState } from 'react';
// // import Project from '../../api/project';
// // import { Link } from "react-router-dom";
// // import PageTitle from '../../components/pagetitle/PageTitle';
// // import Scrollbar from '../../components/scrollbar/scrollbar';
// // import CtaSection from '../../components/CtaSection/CtaSection';
// // // import Header from '../../components/header/Header';
// // // import Footer from '../../components/footer/Footer';

// // const PortfolioPage = (props) => {

// //     const [activeFilter, setActiveFilter] = useState('all');

// //     const ClickHandler = () => {
// //         window.scrollTo(10, 0);
// //     }

// //     const handleFilterClick = (filter) => {
// //         setActiveFilter(filter);
// //     }

// //     // const filteredProjects = activeFilter === 'all'
// //     //     ? Project.slice(9, 18)
// //     //     : Project.slice(9, 18).filter(project => project.category === activeFilter);
// //     const filteredProjects = Project.map(project => project );

// //     return (
// //         <Fragment>
// //             <main className="page_content about-page">
// //                 <PageTitle pageTitle={'Our Portfolio'} pagesub={'Portfolio 😍'} pageTop={'Our'} />
// //                 <section className="portfolio_section section_space bg-light">
// //                     <div className="container">
// //                         <div className="filter_elements_nav">
// //                             <ul className="unordered_list justify-content-center">
// //                                 <li className={activeFilter === 'all' ? 'active' : ''} onClick={() => handleFilterClick('all')}>See All</li>
// //                                 <li className={activeFilter === 'technology' ? 'active' : ''} onClick={() => handleFilterClick('technology')}>Technology</li>
// //                                 <li className={activeFilter === 'helpdesk' ? 'active' : ''} onClick={() => handleFilterClick('helpdesk')}>Helpdesk</li>
// //                                 <li className={activeFilter === 'analysis' ? 'active' : ''} onClick={() => handleFilterClick('analysis')}>Analysis</li>
// //                                 <li className={activeFilter === 'marketing' ? 'active' : ''} onClick={() => handleFilterClick('marketing')}>Marketing</li>
// //                             </ul>
// //                         </div>
// //                         <div className="filter_elements_wrapper row">
// //                             {filteredProjects.map((project, prj) => (
// //                                 <div className="col-lg-6" key={prj}>
// //                                     <div className="portfolio_block portfolio_layout_2">
// //                                         <div className="portfolio_image">
// //                                             <Link onClick={ClickHandler} className="portfolio_image_wrap bg-light" to={`/portfolio_details/${project.slug}`}>
// //                                                 <img src={project.pImg} alt="Mobile App Design" />
// //                                             </Link>
// //                                         </div>
// //                                         <div className="portfolio_content">
// //                                             <h3 className="portfolio_title">
// //                                                 <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}>
// //                                                     {project.title}
// //                                                 </Link>
// //                                             </h3>
// //                                             <ul className="category_list unordered_list">
// //                                                 <li><Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}><i className="fa-solid fa-tags"></i> {project.thumb1}</Link></li>
// //                                                 <li><Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}><i className="fa-solid fa-building"></i> {project.thumb2}</Link></li>
// //                                             </ul>
// //                                         </div>
// //                                     </div>
// //                                 </div>
// //                             ))}
// //                         </div>
// //                     </div>
// //                 </section>

// //                 <CtaSection />
// //             </main>
// //             <Scrollbar />
// //         </Fragment>
// //     )
// // };

// // export default PortfolioPage;



// import React, { Fragment, useState } from 'react';
// import Project from '../../api/project';
// import { Link } from "react-router-dom";
// import PageTitle from '../../components/pagetitle/PageTitle';
// import Scrollbar from '../../components/scrollbar/scrollbar';
// import CtaSection from '../../components/CtaSection/CtaSection';
// import './portfoliocss.css'

// const PortfolioPage = (props) => {
//     const [activeFilter, setActiveFilter] = useState('all');

//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }

//     const handleFilterClick = (filter) => {
//         setActiveFilter(filter);
//     }

//     const filteredProjects = activeFilter === 'all'
//         ? Project
//         : Project.filter(project => project.category === activeFilter);

//     return (
//         <Fragment>
//             <main className="page_content portfolio-page">
//                 <PageTitle pageTitle={'Our Portfolio'} pagesub={'Case Studies & Projects'} pageTop={'Our'} />
//                 <section className="portfolio_section section_space bg-light">
//                     <div className="container">
//                         <div className="filter_nav">
//                             <ul className="filter_list">
//                                 <li className={activeFilter === 'all' ? 'active' : ''} onClick={() => handleFilterClick('all')}>All</li>
//                                 <li className={activeFilter === 'technology' ? 'active' : ''} onClick={() => handleFilterClick('technology')}>Technology</li>
//                                 <li className={activeFilter === 'helpdesk' ? 'active' : ''} onClick={() => handleFilterClick('helpdesk')}>Helpdesk</li>
//                                 <li className={activeFilter === 'analysis' ? 'active' : ''} onClick={() => handleFilterClick('analysis')}>Analysis</li>
//                                 <li className={activeFilter === 'healthcare' ? 'active' : ''} onClick={() => handleFilterClick('healthcare')}>Health Care</li>
//                             </ul>
//                         </div>
//                         <div className="portfolio_grid">
//                             {filteredProjects.map((project, prj) => (
//                                <div className="portfolio_card" key={prj} style={{ marginBottom: "30px" }}>
//                                <div
//                                  className="portfolio_image"
//                                  style={{
//                                    position: "relative",
//                                    width: "100%",
//                                    height: "350px",
//                                    overflow: "hidden",
//                                    borderRadius: "16px",
//                                  }}
//                                >
//                                  <Link
//                                    onClick={ClickHandler}
//                                    className="portfolio_image_wrap"
//                                    to={`/portfolio_details/${project.slug}`}
//                                    style={{ display: "block", width: "100%", height: "100%" }}
//                                  >
//                                    <img
//                                      src={project.pImg}
//                                      alt={project.title}
//                                      className="portfolio_img"
//                                      style={{
//                                        width: "100%",
//                                        height: "100%",
//                                        objectFit: "cover",
//                                        transition: "transform 0.3s ease",
//                                      }}
//                                    />
//                                  </Link>
//                                </div>
//                                <div
//                                  className="portfolio_content"
//                                  style={{
//                                    textAlign: "center",
//                                    padding: "20px",
//                                    backgroundColor: "#fff",
//                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//                                    borderRadius: "16px",
//                                    marginTop: "-20px",
//                                    zIndex: 1,
//                                    position: "relative",
//                                  }}
//                                >
//                                  <h3
//                                    className="portfolio_title"
//                                    style={{
//                                      fontSize: "1.5rem",
//                                      fontWeight: "bold",
//                                      marginBottom: "10px",
//                                      color: "#333",
//                                    }}
//                                  >
//                                    <Link
//                                      onClick={ClickHandler}
//                                      to={`/portfolio_details/${project.slug}`}
//                                      style={{ textDecoration: "none", color: "#333" }}
//                                    >
//                                      {project.title}
//                                    </Link>
//                                  </h3>
//                                  <ul
//                                    className="portfolio_info"
//                                    style={{
//                                      listStyle: "none",
//                                      padding: 0,
//                                      margin: 0,
//                                      display: "flex",
//                                      justifyContent: "center",
//                                      gap: "15px",
//                                      color: "#666",
//                                      fontSize: "0.9rem",
//                                    }}
//                                  >
//                                    <li>
//                                      <i className="fa-solid fa-tags" style={{ marginRight: "5px" }}></i>
//                                      {project.thumb1}
//                                    </li>
//                                    <li>
//                                      <i className="fa-solid fa-building" style={{ marginRight: "5px" }}></i>
//                                      {project.thumb2}
//                                    </li>
//                                  </ul>
//                                </div>
//                              </div>
                             
//                             ))}
//                         </div>
//                     </div>
//                 </section>
//                 <CtaSection />
//             </main>
//             <Scrollbar />
//         </Fragment>
//     )
// };

// export default PortfolioPage;




import React, { Fragment, useState } from 'react';
import Project from '../../api/project';
import { Link } from "react-router-dom";
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CtaSection from '../../components/CtaSection/CtaSection';
import './portfoliocss.css'


const PortfolioPage = (props) => {
  const [activeFilter, setActiveFilter] = useState("all");

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const filteredProjects = activeFilter === "all"
    ? Project
    : Project.filter((project) => project.category === activeFilter);

  return (
    <Fragment>
      <main className="page_content portfolio-page">
        <PageTitle
          pageTitle={"Our Portfolio"}
          pagesub={""}
          pageTop={""}
        />
        <section className="portfolio_section section_space bg-light">
          <div className="container">
            {/* Filter Navigation */}
            <div className="filter_nav">
              <ul className="filter_list">
                {["all", "technology", "helpdesk", "analysis", "healthcare", "security", "education", "business"].map(
                  (filter) => (
                    <li
                      key={filter}
                      className={activeFilter === filter ? "active" : ""}
                      onClick={() => handleFilterClick(filter)}
                    >
                      {filter.charAt(0).toUpperCase() + filter.slice(1)}
                    </li>
                  )
                )}
              </ul>
            </div>

            {/* Portfolio Grid */}
            <div className="portfolio_grid">
              {filteredProjects.map((project, prj) => (
                <div className="portfolio_card" key={prj}>
                  <div className="portfolio_image">
                    <Link
                      onClick={ClickHandler}
                      className="portfolio_image_wrap"
                      to={`/portfolio_details/${project.slug}`}
                    >
                      <img
                        src={project.pImg}
                        alt={project.title}
                        className="portfolio_img"
                      />
                    </Link>
                  </div>
                  <div className="portfolio_content">
                    <h3 className="portfolio_title">
                      <Link
                        onClick={ClickHandler}
                        to={`/portfolio_details/${project.slug}`}
                      >
                        {project.title}
                      </Link>
                    </h3>
                    <ul className="portfolio_info">
                      <li>
                        <i className="fa-solid fa-tags"></i> {project.thumb1}
                      </li>
                      <li>
                        <i className="fa-solid fa-building"></i> {project.thumb2}
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <CtaSection />
      </main>
      <Scrollbar />
    </Fragment>
  );
};

export default PortfolioPage;
